import { axios } from '@/utils/request'

const api = {
  weiyuanhuiList: '/wyhadminapi/weiyuanhui/weiyuanhuiList',
  userDetail: '/wyhadminapi/user/userdetail',
  userEdit: '/wyhadminapi/user/useredit',
  userGroupList: '/wyhadminapi/user/userGroupList',
  setPassword: '/wyhadminapi/user/setPassword',
  userOptions: '/wyhadminapi/user/userOptions',
  editPassword: '/wyhadminapi/user/editPassword',
  wyhSetting: '/wyhadminapi/weiyuanhui/wyhSetting',
  getWyhSetting: '/wyhadminapi/weiyuanhui/getWyhSetting',
  getWyhUserList: '/wyhadminapi/weiyuanhui/getWyhUserList',
  addWyhUser: '/wyhadminapi/weiyuanhui/addWyhUser',
  deleteWyhUser: '/wyhadminapi/weiyuanhui/deleteWyhUser',
  getSubWyhList: '/wyhadminapi/weiyuanhui/getSubWyhList',
}

export default api

export function getWeiyuanhuiList(parameter) {
  return axios({
    url: api.weiyuanhuiList,
    method: 'get',
    params: parameter
  })
}

export function editPassword(parameter) {
  return axios({
    url: api.editPassword,
    method: 'post',
    data: parameter
  })
}
export function getUserDetail(parameter) {
  return axios({
    url: api.userDetail,
    method: 'get',
    params: parameter
  })
}

export function editUser(parameter) {
  return axios({
    url: api.userEdit,
    method: 'post',
    data: parameter
  })
}

export function getUserGroupList(parameter) {
  return axios({
    url: api.userGroupList,
    method: 'get',
    params: parameter
  })
}
export function setPassword(parameter) {
  return axios({
    url: api.setPassword,
    method: 'get',
    params: parameter
  })
}


export function getUserOptions(parameter) {
  return axios({
    url: api.userOptions,
    method: 'get',
    params: parameter
  })
}



export function wyhSetting(parameter) {
  return axios({
    url: api.wyhSetting,
    method: 'post',
    data: parameter
  })
}
export function getWyhSetting(parameter) {
  return axios({
    url: api.getWyhSetting,
    method: 'post',
    data: parameter
  })
}
export function getWyhUserList(parameter) {
  return axios({
    url: api.getWyhUserList,
    method: 'post',
    data: parameter
  })
}
export function deleteWyhUser(parameter) {
  return axios({
    url: api.deleteWyhUser,
    method: 'post',
    data: parameter
  })
}
export function addWyhUser(parameter) {
  return axios({
    url: api.addWyhUser,
    method: 'post',
    data: parameter
  })
}
export function getSubWyhList(parameter) {
  return axios({
    url: api.getSubWyhList,
    method: 'post',
    data: parameter
  })
}